import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["singleTab", "multipleTab", "recurringTab", "singleFields", "multipleFields", "recurringFields", "eventTypeInput"]

  connect() {
    const eventType = this.eventTypeInputTarget.value;
    const formattedEventType = eventType.replace(/_/g, '-');
    this.activateTab(`${formattedEventType}-tab`);
  }

  activateTab(tabId) {
    const tabElement = document.getElementById(tabId);
    if (tabElement) {
      tabElement.click();
    }
  }

  switchTab(event) {
    const activeTabId = event.target.getAttribute('id');

    if (activeTabId === "single-event-tab") {
      this.clearAndDisableFields(this.multipleFieldsTarget);
      this.clearAndDisableFields(this.recurringFieldsTarget);
      this.enableFields(this.singleFieldsTarget);
      this.updateEventType('single_event');
    } else if (activeTabId === "multiple-event-tab") {
      this.clearAndDisableFields(this.singleFieldsTarget);
      this.clearAndDisableFields(this.recurringFieldsTarget);
      this.enableFields(this.multipleFieldsTarget);
      this.updateEventType('multiple_event');
    } else if (activeTabId === "recurring-event-tab") {
      this.clearAndDisableFields(this.singleFieldsTarget);
      this.clearAndDisableFields(this.multipleFieldsTarget);
      this.enableFields(this.recurringFieldsTarget);
      this.updateEventType('recurring_event');
    }
  }

  clearAndDisableFields(fieldsContainer) {
    const inputs = fieldsContainer.querySelectorAll('input, select, textarea');
    inputs.forEach(input => {
      if (input.tagName === 'SELECT') {
        input.value = input.options[0].value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (input.type === 'checkbox') {
        input.checked = false;
      } else {
        input.value = '';
      }
      input.disabled = true;
    });
  }

  enableFields(fieldsContainer) {
    const inputs = fieldsContainer.querySelectorAll('input, select, textarea');
    inputs.forEach(input => {
      input.disabled = false;
    });
  }

  updateEventType(eventType) {
    this.eventTypeInputTarget.value = eventType;
  }
}
